import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar, Parallax, FreeMode, Zoom, A11y, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, EffectCards, EffectCreative } from 'swiper/modules';

const Slider = ({ attributes, Content, initSlide = 0, isBackend = false, custom = {} }) => {
	const { slides, options } = attributes;
	const { breakpoints, autoplay, initialSlide, restOptions } = options;
	const { enabled: autoplayEnabled, ...autoplayOptions } = autoplay;
	// const { dir, direction, centeredSlides,   grabCursor, slideToClickedSlide, loop, rewind, effect, fadeEffect, coverflowEffect, flipEffect, cubeEffect, cardsEffect, creativeEffect, speed, navigation, pagination, autoplay, scrollbar, freeMode, keyboard, mousewheel, parallax, accessibility, zoom } = options;

	const responsiveProps = isBackend ? { slidesPerView: breakpoints[custom.breakOpt].slidesPerView, spaceBetween: breakpoints[custom.breakOpt].spaceBetween } : { breakpoints }

	return <Swiper
		className='evssSlider'
		{...responsiveProps}
		initialSlide={isBackend ? initSlide : initialSlide}
		{...restOptions}
		autoplay={autoplayEnabled && !isBackend ? autoplayOptions : false}
		modules={[EffectFade, EffectCube, EffectCoverflow, EffectFlip, EffectCards, EffectCreative, Navigation, Pagination, Autoplay, Scrollbar, FreeMode, Keyboard, Mousewheel, Parallax, A11y, Zoom, Virtual]}

	// onSwiper={(swiper) => console.log(swiper)}
	// onSlideChange={() => console.log('slide change')}
	>
		{slides.map((slide, index) => {
			const { content } = slide;

			return <SwiperSlide key={index} className={`slide${index + 1}`}>
				<Content content={content} />
			</SwiperSlide>
		})}
	</Swiper>
}
export default Slider;